import guideSvg from "../pages/guides/assets/guide.svg";

type GuideCompletionBadgeProps = {
  completionRate: number | null | undefined;
  className?: string;
};

export const GuideCompletionBadge = ({ completionRate, className }: GuideCompletionBadgeProps) => {
  const normalized =
    typeof completionRate === "number" && Number.isFinite(completionRate)
      ? Math.min(100, Math.max(0, Math.round(completionRate)))
      : 0;

  const label = `${normalized}% completion`;

  return (
    <div
      className={className}
      style={{
        display: "flex",
        padding: "8px 12px",
        alignItems: "center",
        gap: 8,
        borderRadius: "var(--border-radius-default)",
        background: "var(--Theme-subdued-10, #E8ECEB)",
        color: "var(--Text-Dark-Grey, #2F3332)",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      }}
      aria-label={label}
    >
      <img
        src={guideSvg}
        alt=""
        aria-hidden="true"
        style={{ width: 12, height: 12, display: "block" }}
      />
      {label}
    </div>
  );
};

export default GuideCompletionBadge;
